<template>
    <div class="corporate-survey">
        <div class="banner-wrap">
            <div class="title">{{ data.title }}</div>
            <img class="banner" :src="data.mobileBanner.url" :alt="data.title" />
        </div>
        <index-bar :bars="indexBar"></index-bar>
        <div class="content">
            <div :id="indexBar[0]" class="title-wrap">{{ data.bannerTitle }}</div>
            <div class="content-wrap ck-content" v-html="data.bannerContent"></div>
            <div :id="indexBar[1]" class="title-wrap">{{ data.iframe.title }}</div>
            <div class="content-wrap">
                <iframe :src="data.iframe.url" frameborder="0" width="100%" height="740px"></iframe>
            </div>
            <div class="enter">
                <a v-for="item in data.moduleList" :key="item.id" :href="item.mobileUrl" class="item">
                    <div>
                        <img :src="item.moduleCover.url" :alt="item.moduleName" />
                        <div class="title">{{ item.moduleName }}</div>
                        <div class="des">{{ item.moduleTitle }}</div>
                    </div></a
                >
            </div>
        </div>
    </div>
</template>

<script>
import ajax from '@/api/ajax'
import indexBar from './components/index-bar.vue'

export default {
    name: 'CorporateSurvey',
    components: {
        indexBar
    },
    data() {
        return {
            data: {},
            indexBar: []
        }
    },
    computed: {},
    created() {
        ajax.investorRelationsHome().then(res => {
            this.data = res
        })
        ajax.getHomeMenus().then(homeRes => {
            const { menus = [] } = homeRes
            const investorRelationItem = menus.find(i => i.key === 'investorRelation')
            const { children } = investorRelationItem
            const bars = children.find(i => i.key === 'corporateSurvey')
            this.indexBar = bars.indexBar
        })
    },
    methods: {}
}
</script>

<style lang="scss" scoped>
.corporate-survey {
    .banner-wrap {
        height: 480px;
        position: relative;
        .title {
            font-weight: 500;
            font-size: 60px;
            color: #ffffff;
            position: absolute;
            left: 40px;
            top: 80px;
        }
        .banner {
            width: 100%;
            height: 100%;
            display: block;
        }
    }
    .content {
        padding: 60px 40px 0 40px;
        .title-wrap {
            font-weight: 500;
            font-size: 42px;
            color: #333333;
            margin-bottom: 40px;
        }
        .content-wrap {
            margin-bottom: 60px;
        }
        .enter {
            display: flex;
            justify-content: space-between;
            .item {
                width: 210px;
                background: #f5f5f5;
                border-radius: 20px;
                padding-bottom: 18px;
                .title {
                    font-weight: 500;
                    font-size: 26px;
                    line-height: 26px;
                    margin-top: 4px;
                    color: #333333;
                    padding: 0 14px;
                }
                .des {
                    font-weight: 400;
                    font-size: 18px;
                    margin-top: 10px;
                    color: #333333;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    padding: 0 14px;
                }
                img {
                    width: 100%;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/investor/corporate-survey.vue